import { render } from "./EditTraitement.vue?vue&type=template&id=dc948cb8&scoped=true"
import script from "./EditTraitement.vue?vue&type=script&lang=js"
export * from "./EditTraitement.vue?vue&type=script&lang=js"

import "./EditTraitement.vue?vue&type=style&index=0&id=dc948cb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc948cb8"]])

export default __exports__